import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { vipEmailsTemplateAdd, vipEmailsTemplateUpdate } from "@/api/gmtool/packageCode";
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    serverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this,
        _rules;

    var validatePass = function validatePass(rule, value, callback) {
      if (value == '' || value < 0 || value > 65535) {
        callback(new Error(_this.$t('pleaseInputCorrectNumber')));
      } else {
        callback();
      }
    };

    var validateuids = function validateuids(rule, value, callback) {
      var regex = /[\u4e00-\u9fa5，]/;

      if (regex.test(value) || !value) {
        callback(new Error(_this.$t('roleIdIncorrect')));
      } else {
        callback();
      }
    };

    return {
      titleName: "",
      delayList: [{
        label: this.$t('yes'),
        value: 1
      }, {
        label: this.$t('no'),
        value: 2
      }],
      paramsData: {
        content: [],
        template_type: 0,
        is_default: [],
        language: [],
        reward: [],
        template_name: '',
        default_content: [],
        type: 'all_role'
      },
      isTemplate: 0,
      date: [],
      dialogShow: false,
      whetherNot: [{
        label: this.$t('allPlayers'),
        value: 'all_role'
      }, {
        label: this.$t('onlinePlayers'),
        value: 'online_role'
      }, {
        label: this.$t('selectedPlayers'),
        value: 'list_role'
      }, {
        label: this.$t('conditionList'),
        value: 'limit'
      }],
      rules: (_rules = {
        template_name: [{
          required: true,
          message: this.$t('pleaseInputTemplateName'),
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: this.$t('pleaseInputContent'),
          trigger: "blur"
        }],
        item_num: [{
          required: true,
          message: this.$t('pleaseInputQuantity'),
          trigger: "blur"
        }],
        is_default: [{
          required: true,
          message: this.$t('pleaseSelectIsTemplate'),
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }]
      }, _defineProperty(_rules, "content", [{
        required: true,
        message: this.$t('pleaseInputEmailContent'),
        trigger: "blur"
      }]), _defineProperty(_rules, "default_content", [{
        required: true,
        message: this.$t('pleaseAddContent'),
        trigger: "blur"
      }]), _rules),
      isshot: false
    };
  },
  created: function created() {},
  methods: {
    addtag: function addtag(data, index) {
      this.paramsData.default_content[index].content = "".concat(this.paramsData.default_content[index].content).concat(data);
    },
    open: function open(datas, type) {
      var _this2 = this;

      var data = datas ? JSON.parse(JSON.stringify(datas)) : datas;
      this.dialogShow = true;

      if (data && !type) {
        var parsedReward = JSON.parse(data.reward);
        parsedReward.map(function (i) {
          //i.type_id = i.type_id.toString();
          var rawId = i.type_id.toString();

          var isExist = _this2.articleList.some(function (item) {
            return item.id.toString() == rawId;
          });

          if (isExist) {
            // 1. 如果存在：赋值给下拉框，手写框留空
            i.type_id = rawId;

            _this2.$set(i, 'custom_input', '');
          } else {
            // 2. 如果不存在：说明是用户手写的，下拉框留空，赋值给手写输入框
            i.type_id = '';

            _this2.$set(i, 'custom_input', rawId);
          }

          i.ispermanent = i.expire == 0 ? true : false;
        });
        var d = {
          id: data.id,
          is_default: [],
          language: [],
          reward: parsedReward,
          template_type: data.template_type,
          default_content: JSON.parse(data.default_content),
          template_name: data.template_name
        };
        console.log("data===", data);
        console.log("d===", d);
        console.log("this.articleList", this.articleList);
        this.isTemplate = JSON.parse(data.default_content)[0].is_default;
        this.paramsData = _objectSpread({}, d);
      }
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    selectAll: function selectAll() {
      if (this.paramsData.server_ids.length < this.serverList.length) {
        var server_ids = [];
        this.serverList.map(function (item) {
          server_ids.push(item.serverID);
        });
        server_ids.unshift('全选');
        this.paramsData.server_ids = [].concat(server_ids);
      } else {
        // 取消全选
        this.paramsData.server_ids = [];
      }
    },
    changeSelect: function changeSelect(val) {
      if (!val.includes('全选') && val.length === this.serverList.length) {
        this.paramsData.server_ids.unshift('全选');
      } else if (val.includes('全选') && val.length - 1 < this.serverList.length) {
        this.paramsData.server_ids = this.paramsData.server_ids.filter(function (item) {
          return item !== '全选';
        });
      }
    },
    removeTag: function removeTag(val) {
      if (val === '全选') {
        this.paramsData.server_ids = [];
      }
    },
    addDomain: function addDomain() {
      this.paramsData.reward.push({
        num: '',
        expire: '',
        ispermanent: false,
        type_id: ''
      });
    },
    removeDomain: function removeDomain(item) {
      var index = this.paramsData.reward.indexOf(item);

      if (index !== -1) {
        this.paramsData.reward.splice(index, 1);
      }
    },
    addContent: function addContent() {
      this.paramsData.default_content.push({
        disabled: false,
        content: '',
        language: '',
        title: '',
        is_default: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.paramsData.default_content.indexOf(item);

      if (index !== -1) {
        this.paramsData.default_content.splice(index, 1);
      }
    },
    clearData: function clearData(isClearId) {
      var isClearContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.isTemplate = isClearContent ? 0 : this.isTemplate;
      this.paramsData = {
        id: isClearId ? '' : this.paramsData.id,
        is_default: [],
        language: [],
        reward: isClearContent ? [] : this.paramsData.reward,
        type: this.paramsData.type,
        template_name: '',
        default_content: isClearContent ? [] : this.paramsData.default_content
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataChange: function dataChange(e) {
      this.paramsData.start_time = e[0] / 1000;
      this.paramsData.end_time = e[1] / 1000;
    },
    isTemplateChange: function isTemplateChange(e) {
      if (e == 0 && this.paramsData.template_type == 1) {
        this.paramsData.default_content = [];
      }

      this.paramsData.template_type = 0;
    },
    templateTypeChange: function templateTypeChange(e) {
      var _this3 = this;

      this.paramsData.default_content = [];
      var list = [];

      if (e == 1) {
        list = this.compensationList;
      } else if (e == 2) {
        list = this.awardDistribution;
      }

      list.forEach(function (i) {
        _this3.paramsData.default_content.push({
          disabled: true,
          content: i.content,
          language: i.value,
          title: i.title,
          is_default: '1'
        });
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this4.paramsData));
          var newList = [];
          data.reward.forEach(function (item) {
            var finalTargetId = item.type_id ? item.type_id : item.custom_input;
            newList.push({
              type_id: parseInt(finalTargetId),
              expire: item.ispermanent ? 0 : item.expire,
              num: parseInt(item.num)
            });
          });
          console.log("this.isTemplate", _this4.isTemplate);
          data.reward = newList.length ? JSON.stringify(newList) : "";
          data.default_content.forEach(function (item) {
            item.is_default = _this4.isTemplate;
          });
          var reqFn = data.id ? vipEmailsTemplateUpdate : vipEmailsTemplateAdd;
          var paramsData = {
            id: data.id,
            default_content: data.default_content,
            reward: data.reward,
            template_name: data.template_name,
            template_type: data.template_type
          };
          reqFn(_objectSpread({}, paramsData)).then(function (res) {
            if (res.code == 200 || res.status == 200) {
              _this4.$message({
                message: _this4.$t('operationSuccess'),
                type: 'success'
              });

              _this4.dialogShow = false;

              _this4.$emit('change');
            }
          });
        }
      });
    }
  }
};